module.exports = __webpack_public_path__ + "img/logo.e3b357f2.svg";